import Moment from 'moment'
import PropTypes from 'prop-types'
import { useState, useEffect, useRef, useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { Events, scroller } from 'react-scroll'
import { withValidador } from '../hoc/withValidador'
import * as publicacionService from '../servicios/publicacionesTemporalesService'
import LinkButton from '../ui/LinkButton'
import AgregarFotos from './AgregarFotos'
import AsistenteFlechas from './AsistenteFlechas'
import Borde from './Borde'
import CaracteristicasProducto from './CaracteristicasProducto'
import CategoriasPrincipales from './CategoriasPrincipales'
import DescripcionProducto from './DescripcionProducto'
import { getEsquema } from './esquema'
import Exposicion from './exposicion/Exposicion'
import FechaPublicacion from './FechaPublicacion'
import IndicarCategorias from './IndicarCategorias'
import IndicarEtiquetas from './IndicarEtiquetas'
import IndicarPrecio from './IndicarPrecio'
import IndicarProducto from './IndicarProducto'
import IndicarProductoEstado from './IndicarProductoEstado'
import ListaDeVentas from './ListaDeVentas'
import Ofertas from './Ofertas'
import './Publicar.css'
import { PublicacionMasiva } from './PublicacionMasiva'
import TipoPublicacion from './TipoPublicacion'
import VentasEspeciales from './VentasEspeciales'

const CENTER_DIVISOR = 2

const ENVIO_A_CARGO_COMPRADOR = 3

const Publicar = ({ Validador }) => {
  const navigate = useNavigate()
  const paso2 = 2
  const paso3 = 3
  const paso4 = 4
  const paso5 = 5
  const paso6 = 6
  const paso7 = 7
  const paso8 = 8
  const paso9 = 9
  const paso10 = 10
  const paso11 = 11
  const paso12 = 12
  // Refs
  const refPaso0 = useRef(null)
  const refPaso1 = useRef(null)
  const refPaso2 = useRef(null)
  const refPaso3 = useRef(null)
  const refPaso4 = useRef(null)
  const refPaso5 = useRef(null)
  const refPaso6 = useRef(null)
  const refPaso7 = useRef(null)
  const refPaso8 = useRef(null)
  const refPaso9 = useRef(null)
  const refPaso10 = useRef(null)
  const refPaso11 = useRef(null)
  const refPaso12 = useRef(null)

  // Constants
  const pasos = 12
  const offSet = -300

  // Initial publicacion object
  const initialPublicacion = {
    alicuota: 0,
    idPublicacionTemporal: 0,
    idVendedor: parseInt(localStorage.getItem('idUsuario')),
    titulo: '',
    descripcion: '',
    desde: Moment().format('YYYY-MM-DD'),
    hasta: '',
    idListaVenta: 0,
    etiquetas: '',
    idCategoria: 0,
    metadatos: [],
    esNuevo: null,
    esScrap: false,
    youtube: '',
    conStock: false,
    conStockAPedido: false,
    conPresupuesto: false,
    cantDisponible: 0,
    cantMinPedido: 0,
    precioUnitario: 0,
    envioGratis: false,
    preciosMayorista: [
      {
        cantidad: 0,
        idUnidadMedida: 0,
        precio: 0,
        id: 0
      }
    ],
    tipoProducionCant: 0,
    tipoProducionUnidad: 0,
    idMoneda: 0,
    capacidadMax: 0,
    extensionGarantia: false,
    mediosPagos: [],
    mediosEnvios: [],
    garantias: [],
    garantiaPlazo: 0,
    garantiaMonto: 0,
    porcDcto: 0,
    ofertaDesde: null,
    ofertaHasta: null,
    idPublicacionExposicion: 0,
    nombreListaEnvio: ''
  }

  // State
  const [errores, setErrores] = useState({})
  const [idPublicacionTemporal, setIdPublicacionTemporal] = useState(0)
  const [paso, setPaso] = useState(-1)
  const [idVendedor] = useState(parseInt(localStorage.getItem('idUsuario')))
  const [verCategoriasPrincipales, setVerCategoriasPrincipales] = useState(false)
  const [agregarEspacioFinal, setAgregarEspacioFinal] = useState(false)
  const [publicacion, setPublicacion] = useState(initialPublicacion)
  const [esScrap, setEsScrap] = useState(false)
  const [esMasiva, setEsMasiva] = useState(false)

  // Mount effect
  useEffect(() => {
    Events.scrollEvent.register('begin', () => {})

    Events.scrollEvent.register('end', (to) => {
      to === 'pasoArriba' && setVerCategoriasPrincipales(false)
    })

    return () => {
      Events.scrollEvent.remove('begin')
      Events.scrollEvent.remove('end')
      document.body.classList.remove('sin-scroll')
    }
  }, [])

  const refMap = {
    0: refPaso0,
    1: refPaso1,
    2: refPaso2,
    3: refPaso3,
    4: refPaso4,
    5: refPaso5,
    6: refPaso6,
    7: refPaso7,
    8: refPaso8,
    9: refPaso9,
    10: refPaso10,
    11: refPaso11,
    12: refPaso12
  }

  const getAlto = useCallback((pasoNum) => {
    const refPasoActual = refMap[pasoNum]
    const refPasoAnterior = refMap[pasoNum - 1]

    if (refPasoActual?.current && refPasoAnterior?.current) {
      return (
        (refPasoActual.current.offsetHeight - refPasoAnterior.current.offsetHeight) /
        CENTER_DIVISOR
      )
    }
    return 0
  }, [])

  const getAltos = useCallback(
    (cantPasos) => {
      let offSetCalc = 0
      for (let i = 0; i < cantPasos; i++) {
        offSetCalc += getAlto(cantPasos - i)
      }
      return offSetCalc
    },
    [getAlto]
  )

  const moverScroll = useCallback(() => {
    if (paso <= pasos) {
      const offSetCalc = offSet + getAltos(paso)

      scroller.scrollTo('borde-normal-active', {
        duration: 800,
        delay: 0,
        smooth: 'easeInOutQuart',
        offset: offSetCalc
      })
    }
  }, [paso, pasos, offSet, getAltos])

  // Effect for paso changes
  useEffect(() => {
    if (paso === -1) {
      scroller.scrollTo('pasoArriba', {
        duration: 500,
        delay: 0,
        smooth: 'easeInOutQuart',
        offset: -150
      })
    } else {
      moverScroll()
    }
  }, [paso, moverScroll])

  const handleTipoPublicacion = (masiva) => {
    setVerCategoriasPrincipales(true)
    setTimeout(() => {
      scroller.scrollTo('divCategorias', {
        duration: 500,
        delay: 0,
        smooth: 'easeInOutQuart',
        offset: 0
      })
    }, 0)
    setEsMasiva(masiva)
    setAgregarEspacioFinal(true)
  }

  const irAPaso = (siguiente) => {
    setPaso((prevPaso) => prevPaso + (siguiente ? 1 : -1))
  }

  const handlePasoAnterior = () => {
    irAPaso(false)
    submit()
  }

  const pasoValido = useCallback(
    (name, value) => {
      const datosActualizados = {
        ...publicacion,
        [name]: value
      }
      const datosParaValidar = value === undefined ? publicacion : datosActualizados
      const erroresValidation = Validador.validarDato(
        getEsquema(),
        datosParaValidar,
        name
      )
      setErrores(erroresValidation || {})
      if (erroresValidation) {
        return false
      } else {
        return true
      }
    },
    [publicacion, Validador]
  )

  const valido = useCallback(
    (pasoNum, name) => (paso === pasoNum && !pasoValido(name) ? false : true),
    [paso, pasoValido]
  )

  const handlePasoSiguiente = () => {
    if (paso === 0) {
      Validador.cargarEsquema(getEsquema())
    }

    if (!valido(0, 'titulo')) {
      return
    }
    if (!valido(1, 'descripcion')) {
      return
    }
    if (!valido(paso2, 'desde') || !valido(paso2, 'hasta')) {
      return
    }
    if (!valido(paso5, 'idCategoria')) {
      return
    }
    if (!valido(paso7, 'esNuevo')) {
      return
    }
    if (
      !valido(paso9, 'idMoneda') ||
      !valido(paso9, 'precioUnitario') ||
      !valido(paso9, 'alicuota')
    ) {
      return
    }

    if (
      !valido(paso11, 'porcDcto') ||
      !valido(paso11, 'ofertaDesde') ||
      !valido(paso11, 'ofertaHasta')
    ) {
      return
    }
    if (!valido(paso10, 'mediosPagos') || !valido(paso10, 'mediosEnvios')) {
      return
    }

    if (
      publicacion.mediosEnvios.some((m) => m.idMedioEnvio === ENVIO_A_CARGO_COMPRADOR)
    ) {
      if (!publicacion.idListaEnvio || publicacion.idListaEnvio === 0) {
        setErrores((prev) => ({
          ...prev,
          idListaEnvio: 'Debe seleccionar una lista de envíos.'
        }))
        return
      }
    }

    if (paso >= pasos - 1) {
      setAgregarEspacioFinal(false)
    }
    if (paso < pasos) {
      irAPaso(true)
    }

    setTimeout(() => {
      const nextRef = refMap[paso + 1]
      if (nextRef?.current) {
        nextRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }
    }, 0)
    submit()
  }

  const obtenerValor = (value, valueCalculado, checked, type, tipoDato) => {
    let val
    switch (tipoDato) {
      case 'bool':
        val = value === 'true'
        break
      case 'num':
        val = Number(value)
        break
      case 'calc':
        val = valueCalculado
        break
      default:
        val = type === 'checkbox' || type === 'radio' ? checked : value
        break
    }
    return val
  }

  const handleChangeState = (name, value, callBack) => {
    setPublicacion((prevState) => ({
      ...prevState,
      [name]: value
    }))
    if (callBack) {
      callBack()
    }
  }

  const handleChange = (
    { currentTarget: input },
    tipoDato = '',
    valueCalculado = null
  ) => {
    const { name, value, checked, type } = input
    const nuevoValor = obtenerValor(value, valueCalculado, checked, type, tipoDato)

    pasoValido(input.name, nuevoValor)
    moverScroll() //para acomodar scroll vs flechas luego de resolver/mostrar errores... provisorio.

    handleChangeState(
      name,
      nuevoValor,
      () => pasoValido(name, nuevoValor) //verifico si el error desapareció durante el onchange del campo
    )
  }

  const handleGarantia = (name, value) => {
    setPublicacion((prevState) => ({
      ...prevState,
      [name]: value
    }))
  }

  const submit = async () => {
    const publicacionData = {
      ...publicacion,
      esScrap: esScrap
    }

    const publicacionPayload = {
      publicacion: JSON.stringify(publicacionData),
      idPublicacionTemporal: idPublicacionTemporal,
      idVendedor: parseInt(localStorage.getItem('idUsuario'))
    }

    if (idPublicacionTemporal === 0) {
      const { data } = await publicacionService.insertar(publicacionPayload)
      setIdPublicacionTemporal(data.idPublicacionTemporal)
      setPublicacion((prevState) => ({
        ...prevState,
        idPublicacionTemporal: data.idPublicacionTemporal
      }))
    } else {
      await publicacionService.actualizar(publicacionPayload)
    }
  }

  const handlerPublicar = async () => {
    if (!pasoValido('idPublicacionExposicion')) {
      return
    }

    if (Object.keys(errores).length) {
      return false
    }

    await publicacionService.publicar(publicacion)
    limpiarForm()

    navigate('/PublicacionGrabada')
  }

  const limpiarForm = () => {
    setErrores({})
    setIdPublicacionTemporal(0)
    setPaso(-1)
    setVerCategoriasPrincipales(false)
    setAgregarEspacioFinal(false)
    setPublicacion(initialPublicacion)
  }

  const claseActivo = (posicion) => (paso === posicion ? true : false)

  const getErrores = (arrElementos) => {
    let error = null
    arrElementos.forEach((e) => {
      if (errores[e]) {
        error = errores[e]
      }
    })
    return error
  }

  const handleTab = (e) => {
    if (e.key === 'Tab') {
      e.preventDefault()
      handlePasoSiguiente()
    }
    if (e.shiftKey && e.key === 'Tab') {
      e.preventDefault()
      handlePasoAnterior()
    }
  }

  const setCatalogo = (esScrapValue) => {
    setPaso(0)
    setEsScrap(esScrapValue)
  }

  useEffect(() => {
    if (paso === 0 && refPaso0.current) {
      refPaso0.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
    } else if (paso > 0) {
      moverScroll()
    }
  }, [paso, moverScroll])

  return (
    <form onSubmit={(e) => e.preventDefault()} onKeyDown={(e) => handleTab(e)}>
      <div className="pasoArriba">
        <div className="box-publicar">
          <h1 className="text-center">
            Bienvenido! <br /> Comencemos con la publicación...
          </h1>
        </div>
        <TipoPublicacion onClick={handleTipoPublicacion} />

        {verCategoriasPrincipales && (
          <div className="divCategorias">
            <CategoriasPrincipales onClick={setCatalogo} />
          </div>
        )}
        {paso >= 0 &&
          (esMasiva ? (
            <PublicacionMasiva errores={errores} handleChange={handleChange} />
          ) : (
            <div className="row">
              <div className="col-10">
                <Borde
                  titulo="Indicá el título de tu publicación"
                  activo={claseActivo(0)}
                  ref={refPaso0}
                  error={errores.titulo}
                >
                  <IndicarProducto onChange={handleChange} value={publicacion.titulo} />
                </Borde>
                <Borde
                  titulo="Escribí la descripción de tu publicación"
                  activo={claseActivo(1)}
                  ref={refPaso1}
                  error={errores.descripcion}
                >
                  <DescripcionProducto
                    onChange={handleChange}
                    value={publicacion.descripcion}
                  />
                </Borde>
                <Borde
                  titulo="Fecha de Publicación"
                  activo={claseActivo(paso2)}
                  ref={refPaso2}
                  error={errores.desde ? errores.desde : errores.hasta}
                >
                  <FechaPublicacion
                    onChange={handleChange}
                    valueDesde={publicacion.desde}
                    valueHasta={publicacion.hasta}
                  />
                </Borde>
                <Borde
                  titulo="Lista de Ventas"
                  activo={claseActivo(paso3)}
                  ref={refPaso3}
                >
                  <ListaDeVentas
                    idVendedor={idVendedor}
                    onChange={handleChange}
                    onChangeState={handleChangeState}
                    value={publicacion.idListaVenta}
                  />
                </Borde>
                <Borde
                  titulo="Indicá las etiquetas de tu publicación"
                  activo={claseActivo(paso4)}
                  ref={refPaso4}
                >
                  <IndicarEtiquetas
                    onChangeState={handleChangeState}
                    value={publicacion.etiquetas}
                  />
                </Borde>
                <Borde
                  titulo="Indicá a que categoría pertenece"
                  activo={claseActivo(paso5)}
                  ref={refPaso5}
                  error={errores.idCategoria}
                >
                  <IndicarCategorias
                    onChange={handleChange}
                    value={publicacion.idCategoria}
                    esScrap={esScrap}
                  />
                </Borde>
                <Borde
                  titulo="Indicá las características de tu publicación"
                  activo={claseActivo(paso6)}
                  ref={refPaso6}
                >
                  <CaracteristicasProducto
                    onChange={handleChange}
                    value={{ metadatos: publicacion.metadatos }}
                    idCategoria={publicacion.idCategoria}
                  />
                </Borde>
                <Borde
                  titulo="Indicá el estado de tu publicación"
                  activo={claseActivo(paso7)}
                  ref={refPaso7}
                  error={errores.esNuevo}
                >
                  <IndicarProductoEstado
                    onChange={handleChange}
                    checked={publicacion.esNuevo}
                  />
                </Borde>
                <Borde
                  titulo="Agregá las fotos de tu publicación"
                  activo={claseActivo(paso8)}
                  ref={refPaso8}
                >
                  <AgregarFotos
                    value={publicacion.youtube}
                    idPublicacion={0}
                    idPublicacionTemporal={publicacion.idPublicacionTemporal}
                    onChange={handleChange}
                  />
                </Borde>
                <Borde
                  titulo="Indicá el precio de tu publicación"
                  activo={claseActivo(paso9)}
                  ref={refPaso9}
                  error={getErrores([
                    'cantDisponible',
                    'precioUnitario',
                    'idMoneda',
                    'alicuota'
                  ])}
                >
                  <IndicarPrecio
                    values={{
                      conStock: publicacion.conStock,
                      conStockAPedido: publicacion.conStockAPedido,
                      conPresupuesto: publicacion.conPresupuesto,
                      cantDisponible: publicacion.cantDisponible,
                      cantMinPedido: publicacion.cantMinPedido,
                      precioUnitario: publicacion.precioUnitario,
                      idMoneda: publicacion.idMoneda,
                      preciosMayorista: publicacion.preciosMayorista,
                      capacidadMax: publicacion.capacidadMax
                    }}
                    onChange={handleChange}
                    onChangeState={handleChangeState}
                  />
                </Borde>
                <Borde
                  titulo="Condiciones de Venta Especiales"
                  activo={claseActivo(paso10)}
                  ref={refPaso10}
                  error={getErrores([
                    'mediosPagos',
                    'mediosEnvios',
                    'envioGratis',
                    'idListaEnvio'
                  ])}
                >
                  <VentasEspeciales
                    values={{
                      extensionGarantia: publicacion.extensionGarantia,
                      mediosPagos: publicacion.mediosPagos,
                      mediosEnvios: publicacion.mediosEnvios,
                      garantias: publicacion.garantias,
                      envioGratis: publicacion.envioGratis,
                      NombreLista: publicacion.NombreLista
                    }}
                    onChange={handleChange}
                    onAddGarantia={handleGarantia}
                  />
                </Borde>
                <Borde
                  titulo="Oferta!"
                  activo={claseActivo(paso11)}
                  ref={refPaso11}
                  error={
                    errores.porcDcto
                      ? errores.porcDcto
                      : errores.ofertaDesde
                        ? errores.ofertaDesde
                        : errores.ofertaHasta
                  }
                >
                  <Ofertas
                    values={{
                      porcDcto: publicacion.porcDcto,
                      precioUnitario: publicacion.precioUnitario,
                      ofertaDesde: publicacion.ofertaDesde,
                      ofertaHasta: publicacion.ofertaHasta
                    }}
                    onChange={handleChange}
                  />
                </Borde>
                <Borde
                  titulo="Indicá la exposición de tu publicación"
                  activo={claseActivo(paso12)}
                  ref={refPaso12}
                  error={errores.idPublicacionExposicion}
                >
                  <Exposicion
                    onChange={handleChange}
                    checked={publicacion.idPublicacionExposicion}
                    precioUnitario={publicacion.precioUnitario}
                  />
                </Borde>

                {agregarEspacioFinal && <div style={{ marginBottom: '300px' }} />}

                {paso >= 0 && (
                  <div className="row">
                    <div className="col-2"></div>
                    <div className="col">
                      <LinkButton
                        className="btn btn-finalizar-publicacion"
                        onClick={handlerPublicar}
                      >
                        Finalizar la Publicación
                      </LinkButton>
                      <div style={{ marginBottom: '300px' }} />
                    </div>
                    <div className="col-2"></div>
                  </div>
                )}
              </div>
              <div className="col-2">
                <AsistenteFlechas
                  clickPasoAnterior={handlePasoAnterior}
                  clickPasoSiguiente={handlePasoSiguiente}
                  limiteInferior={paso === pasos}
                ></AsistenteFlechas>
              </div>
            </div>
          ))}
      </div>
    </form>
  )
}

Publicar.propTypes = {
  Validador: PropTypes.shape({
    validarDato: PropTypes.func.isRequired,
    cargarEsquema: PropTypes.func.isRequired
  }).isRequired
}

export default withValidador(Publicar)
